import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const FaceMatchingIcon = ({ color = '#fff', size = 15, ...props }) => (
  <svg
    width={size}
    fill="none"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.422.667v1.384h.666V0h-1.86v.667h1.194zM2.507.667H3.7V0H1.84v2.05h.667V.668zM2.507 9.165V7.857H1.84v1.975H3.7v-.667H2.507zM11.422 9.165h-1.194v.667h1.86V7.857h-.666v1.308z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.084 11.317c-1.996-.46-3.854-.864-2.954-2.56C11.869 3.594 9.856.833 6.964.833 4.015.833 2.052 3.7 4.798 8.757c.927 1.707-1 2.109-2.954 2.56-1.995.46-1.841.2-1.841 2.109h13.922c0-1.909.154-1.65-1.841-2.11z"
      fill={color}
    />
  </svg>
);

FaceMatchingIcon.propTypes = propTypes;

export default FaceMatchingIcon;
